import React, { createContext, useState, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
    // Sprawdzamy localStorage, jeśli brak ustawienia to domyślnie ciemny
    const storedTheme = localStorage.getItem('pokerTimerTheme');
    const [darkMode, setDarkMode] = useState(
        storedTheme ? storedTheme === 'dark' : true
    );

    useEffect(() => {
        // Zapisujemy preferencję do localStorage przy każdej zmianie
        localStorage.setItem('pokerTimerTheme', darkMode ? 'dark' : 'light');
    }, [darkMode]);

    const toggleDarkMode = () => {
        setDarkMode(!darkMode);
    };

    return (
        <ThemeContext.Provider value={{ darkMode, toggleDarkMode }}>
            {children}
        </ThemeContext.Provider>
    );
};